// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__B4F2K","plus":"styles_plus__BejXh","key":"styles_key__0aguZ"};